/* ==========================================================================
   KULTA — Cart Drawer + Search Overlay runtime (additive, isolated)
   - Reusa la AJAX Cart API de Shopify y el predictive search existente.
   - No reemplaza lógica previa: solo abre/cierra y refresca el drawer.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  var drawer = document.querySelector('[data-kulta-cart-drawer]');
  var search = document.querySelector('[data-kulta-search-overlay]');
  var overlay = document.querySelector('[data-kulta-drawer-overlay]');

  function isOpen(el) { return el && el.classList.contains('is-open'); }

  /* ---------------- a11y: focus management ---------------- */
  var lastFocused = null;
  function focusables(c) {
    if (!c) return [];
    return Array.prototype.slice.call(c.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }
  function focusInto(c) {
    if (!c) return;
    var target = c.querySelector('[data-kulta-cart-close], [data-kulta-predictive-input], [data-kulta-search-close]') || focusables(c)[0];
    if (!target) return;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    window.requestAnimationFrame(function () {
      if (document.activeElement !== target) {
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      }
    });
  }
  function restoreFocus() { if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} } lastFocused = null; }
  function setExpanded(sel, val) { document.querySelectorAll(sel).forEach(function (t) { t.setAttribute('aria-expanded', val ? 'true' : 'false'); }); }
  function afterClose() {
    window.setTimeout(function () { if (!isOpen(drawer) && !isOpen(search)) restoreFocus(); }, 0);
  }
  function trapTab(e, c) {
    var f = focusables(c); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function showScrim() {
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
    document.body.classList.add('kulta-drawer-open');
  }
  function maybeHideScrim() {
    if (isOpen(drawer) || isOpen(search)) return;
    if (overlay) {
      overlay.classList.remove('is-open');
      window.setTimeout(function () { if (!isOpen(drawer) && !isOpen(search)) overlay.hidden = true; }, 320);
    }
    document.body.classList.remove('kulta-drawer-open');
  }

  /* ---------------- CART ---------------- */
  function openCart() {
    if (!drawer) return;
    if (!isOpen(drawer) && !isOpen(search)) lastFocused = document.activeElement;
    closeSearch();
    drawer.removeAttribute('inert');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setExpanded('[data-kulta-cart-toggle]', true);
    showScrim();
    focusInto(drawer);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    setExpanded('[data-kulta-cart-toggle]', false);
    maybeHideScrim();
    afterClose();
  }
  function updateBadge(count) {
    count = parseInt(count || '0', 10) || 0;
    document.querySelectorAll('[data-kulta-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count < 1;
    });
  }
  function refreshCart() {
    if (!drawer) return Promise.resolve();
    return fetch(ROOT + '?sections=kulta-cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['kulta-cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-kulta-cart-drawer-contents]');
        var cur = drawer.querySelector('[data-kulta-cart-drawer-contents]');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          updateBadge(fresh.getAttribute('data-cart-count'));
          if (isOpen(drawer) && !drawer.contains(document.activeElement)) focusInto(drawer);
        }
      })
      .catch(function () {});
  }

  function currentQty(line) {
    var s = line.querySelector('[data-kulta-cart-qty]');
    return parseInt(s ? s.textContent : '1', 10) || 1;
  }
  function setLine(line, qty) {
    var key = line.getAttribute('data-key');
    if (!key) return;
    if (line.dataset.kultaCartPending) return; // ignore rapid clicks while a change is in flight (prevents lost updates)
    line.dataset.kultaCartPending = '1';
    line.style.opacity = '0.5';
    var clearPending = function () { line.style.opacity = ''; delete line.dataset.kultaCartPending; };
    var safety = window.setTimeout(clearPending, 4000); // never leave a line stuck if the drawer refresh fails
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.clearTimeout(safety); refreshCart(); }) // success rebuilds the drawer (fresh line, no pending flag)
      .catch(function () { window.clearTimeout(safety); clearPending(); });
  }

  /* ---------------- SEARCH ---------------- */
  function openSearch() {
    if (!search) return;
    if (!isOpen(drawer) && !isOpen(search)) lastFocused = document.activeElement;
    closeCart();
    search.removeAttribute('inert');
    search.classList.add('is-open');
    search.setAttribute('aria-hidden', 'false');
    setExpanded('[data-kulta-search-toggle]', true);
    showScrim();
    focusInto(search);
  }
  function closeSearch() {
    if (!search) return;
    search.classList.remove('is-open');
    search.setAttribute('aria-hidden', 'true');
    search.setAttribute('inert', '');
    setExpanded('[data-kulta-search-toggle]', false);
    maybeHideScrim();
    afterClose();
  }

  function closeAll() { closeCart(); closeSearch(); }

  /* ---------------- delegated events ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-kulta-cart-toggle]')) { e.preventDefault(); openCart(); refreshCart(); return; }
    if (t.closest('[data-kulta-cart-close]')) { e.preventDefault(); closeCart(); return; }
    if (t.closest('[data-kulta-search-toggle]')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-kulta-search-close]')) { e.preventDefault(); closeSearch(); return; }
    if (t.closest('[data-kulta-drawer-overlay]')) { closeAll(); return; }

    var line = t.closest('[data-kulta-cart-line]');
    if (line && t.closest('[data-kulta-cart-plus]')) { e.preventDefault(); setLine(line, currentQty(line) + 1); return; }
    if (line && t.closest('[data-kulta-cart-minus]')) { e.preventDefault(); setLine(line, Math.max(0, currentQty(line) - 1)); return; }
    if (line && t.closest('[data-kulta-cart-remove]')) { e.preventDefault(); setLine(line, 0); return; }

    var term = t.closest('[data-kulta-search-term]');
    if (term && search) {
      e.preventDefault();
      var input = search.querySelector('[data-kulta-predictive-input]');
      if (input) {
        input.value = term.getAttribute('data-kulta-search-term') || '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }
      return;
    }
  });

  // upsell add-to-cart (delegated; sobrevive a refresh del drawer)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kulta-cart-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(ROOT + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .catch(function () { if (btn) btn.disabled = false; });
  });

  // gift note (delegated; guarda al cambiar)
  document.addEventListener('change', function (e) {
    var ta = e.target.closest('[data-kulta-cart-note]');
    if (!ta) return;
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ note: ta.value })
    }).catch(function () {});
  });

  // ESC cierra + focus trap (Tab) dentro del drawer/overlay abierto
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); return; }
    if (e.key === 'Tab') {
      if (isOpen(drawer)) trapTab(e, drawer);
      else if (isOpen(search)) trapTab(e, search);
    }
  });

  // aria inicial en los triggers (no rompe nada existente)
  document.querySelectorAll('[data-kulta-cart-toggle], [data-kulta-search-toggle]').forEach(function (t) {
    t.setAttribute('aria-haspopup', 'dialog');
    t.setAttribute('aria-expanded', 'false');
  });
  if (drawer && !isOpen(drawer)) drawer.setAttribute('inert', '');
  if (search && !isOpen(search)) search.setAttribute('inert', '');

  // disparado por kulta.js tras agregar al carrito desde cualquier parte
  document.addEventListener('kulta:cart:added', function () { refreshCart().then(openCart); });
  document.addEventListener('kulta:cart:updated', function () { refreshCart(); });

  // API pública
  window.KultaCart = { open: openCart, close: closeCart, refresh: refreshCart };
  window.KultaSearch = { open: openSearch, close: closeSearch };

  // sync inicial del contador del header
  fetch(ROOT + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { updateBadge(c.item_count); })
    .catch(function () {});
})();
